import React from "react";

import {
  Modal as BaseModal,
  ModalProps as BaseModalProps,
} from "@examspark/common-ui";

import { WindowContext } from "./AppWrapper";

type ModalProps = BaseModalProps;

/**
 * Bonfire modal needs to be aware of the window size, and force a full screen
 * modal on mobile. This is a wrapper around the common-ui modal that does that.
 */
const Modal = (props: ModalProps) => {
  const window = React.useContext(WindowContext);

  return (
    <BaseModal
      {...props}
      size={window.device === "phone" ? "mobile" : props.size}
    >
      {props.children}
    </BaseModal>
  );
};

Modal.PaddedBody = BaseModal.PaddedBody;

export { type ModalProps };
export default Modal;
